import {Component, OnInit} from '@angular/core';
import {IAppSettings} from '../../interfaces/settings';
import {environment} from '../../../environments/environment';
import {TranslateService} from '@ngx-translate/core';
import {UserService} from '../../services/user.service';

@Component({
  selector: 'public-layout',
  templateUrl: './public.component.html',
  styleUrls: ['./public.component.scss']
})
export class PublicLayoutComponent implements OnInit {
  settings: IAppSettings;

  constructor(public user: UserService, public translate: TranslateService) {
    /*
   translate configs
    */
    // this.user.configDEfaultLang();
  }

  ngOnInit() {
    this.settings = environment.appSettings;
  }
}
